import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { QuoteStatus } from "src/app/models/quote/quote-status";
import { QuoteService } from "src/app/services/quote/quote.service";

@Injectable()
export class QuoteStatusResolver  {
    
    constructor(private quoteService: QuoteService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<QuoteStatus[]>> {
        const response = this.quoteService.getStatus().pipe(map(response => { 
            if (response.success) {
                return response.payload.statuses;
            }
            else {
                return [];
            }
        }));
        const responsePromise = new Promise<Observable<QuoteStatus[]>>((resolve, reject) => { resolve( response )});
        return responsePromise;
    }
}